angular
  .module('core.env')
  .config((envServiceProvider) => {
    envServiceProvider.config({
      domains: {
        local: ['localhost', 'dev.local'],
        thaidevops: ['admin.instawash.thaidevops.co'],
        omg: ['admin.dev.omgmotor.com'],
        development: ['dev.instawash.net'],
        awsdev: ['admin-dev.iws-asia.com', 'ec2-54-146-229-41.compute-1.amazonaws.com'],
        production: ['admin.iws-asia.com', 'admin.instawash.net'],
      },
      vars: {
        local: {
          apiUrl: 'http://localhost:3000',
        },
        thaidevops: {
          apiUrl: 'https://api.instawash.thaidevops.co',
        },
        omg: {
          apiUrl: 'https://api.dev.omgmotor.com/v2',
        },
        development: {
          apiUrl: 'http://api-dev.iws-asia.com/v2',
        },        
        proxy: { 
          apiUrl: 'http://ec2-13-124-111-62.ap-northeast-2.compute.amazonaws.com/v2' 
        },
        awsdev: {
          apiUrl: 'https://api-dev.iws-asia.com/v2',
        },
        production: {
          apiUrl: 'https://api.iws-asia.com/v2',
        },              
      },
    });
    
    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();
  });



// WEBPACK FOOTER //
// ./src/app/core/env/env.config.js